<app-header-home [isTransparent]="isTransparent"></app-header-home>
<app-layout-without-header></app-layout-without-header>
<app-media-player></app-media-player>
